import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { FaqAndTopLinksService } from './faq-and-top-links.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';

@Component({
    selector: 'app-faq-and-top-links',
    templateUrl: './faq-and-top-links.component.html',
    styleUrls: ['./faq-and-top-links.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        NgStyle,
    ],
})
export class FaqAndTopLinksComponent implements OnInit, OnDestroy {

  screenWidth: number;

  private subscriptions: ISubscription[];

  private username: string;

  faqLinks: any[];
  topLinks: any[];
  APP_SETTINGS: any;
  constructor(private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private authService: AuthService,
    private linkService: FaqAndTopLinksService,
    private changeDetector: ChangeDetectorRef) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.faqLinks = [];
    this.topLinks = [];
    this.subscriptions = [];
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.linkService.getFAQLinks().subscribe(data => {
      this.faqLinks = data;
      this.subscriptions.push(this.linkService.getTopLinks().subscribe(value => {
        this.spinnerService.hide('bmwSpinner');
        this.topLinks = value;
        this.changeDetector.detectChanges();
      }));
    }));
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  saveToAnalytics(documentTitle) {

    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('FAQ & Top Links', documentTitle, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('FAQ & Top Links', documentTitle);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('FAQ & Top Links', documentTitle, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('FAQ & Top Links', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}
